import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { alpha, Box, IconButton, Typography, useTheme } from '@mui/material';

interface TradePriceInputProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
}

export function TradePriceInput({ value, onChange, label = 'Limit Price' }: TradePriceInputProps) {
  const theme = useTheme();
  const handleDecrease = () => onChange(Math.max(1, value - 1));
  const handleIncrease = () => onChange(Math.min(99, value + 1));

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: '1.125rem', color: 'text.secondary', fontWeight: 600 }}>
          {label}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            bgcolor: alpha(theme.palette.action.hover, 0.05),
            borderRadius: '16px',
            p: 1.25,
            border: '1px solid',
            borderColor: alpha(theme.palette.divider, 0.1),
          }}
        >
          <IconButton
            size="small"
            onClick={handleDecrease}
            sx={{
              bgcolor: 'background.paper',
              width: 36,
              height: 36,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              color: 'text.primary',
              '&:hover': { bgcolor: alpha(theme.palette.background.paper, 0.8) },
            }}
          >
            <RemoveIcon fontSize="small" />
          </IconButton>
          <Typography
            sx={{
              fontSize: '1.75rem',
              fontWeight: 800,
              color: 'text.primary',
              minWidth: 60,
              textAlign: 'center',
              fontFamily: 'var(--font-outfit), sans-serif',
            }}
          >
            {value}¢
          </Typography>
          <IconButton
            size="small"
            onClick={handleIncrease}
            sx={{
              bgcolor: 'background.paper',
              width: 36,
              height: 36,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              color: 'text.primary',
              '&:hover': { bgcolor: alpha(theme.palette.background.paper, 0.8) },
            }}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}
